"use strict";
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var keyboard_events_1 = require("./browser/keyboard-events");
var table_dom_traversal_1 = require("./browser/table-dom-traversal");
var clipboard_reducers_1 = require("./clipboard/clipboard-reducers");
var selection_1 = require("./workspace/selection");
var selection_events_1 = require("./workspace/selection-events");
var workspace_reducers_1 = require("./workspace/workspace-reducers");
function defaultGetCellValue(inputSelector) {
    return function (cell) {
        var input = cell.querySelector(inputSelector);
        if (input.value) {
            return input.value;
        }
        return cell.innerText;
    };
}
function defaultSetCellValue(inputSelector) {
    return function (cell, value) {
        var input = cell.querySelector(inputSelector);
        if (input.value) {
            input.value = String(value);
        }
        else {
            cell.innerHTML = String(value);
        }
    };
}
var VirtualWorksheet = (function () {
    function VirtualWorksheet(table, traverser, options) {
        this.table = table;
        this.traverser = traverser;
        this.options = options;
        this.selection = [];
        this.handleChangeCellKeyPress = this.createKeyPressHandler();
        this.handleFocus = this.createFocusHandler();
        this.handleCopy = this.createCopyEventHandler();
        this.handlePaste = this.createPasteEventHandler();
        this.options.getCellValue = this.options.getCellValue || defaultGetCellValue(this.options.inputSelector);
        this.options.setCellValue = this.options.setCellValue || defaultSetCellValue(this.options.inputSelector);
        this.workspace = {
            pastSelection: selection_1.NoSelection.instance,
            activeSelection: selection_1.NoSelection.instance
        };
    }
    VirtualWorksheet.prototype.attachToTable = function () {
        var _this = this;
        this.table.querySelectorAll("td")
            .forEach(function (cell) {
            cell.tabIndex = 0;
            cell.addEventListener("mousedown", _this.handleFocus);
            cell.addEventListener("keydown", _this.handleChangeCellKeyPress);
            cell.addEventListener("copy", _this.handleCopy);
            cell.addEventListener("paste", _this.handlePaste);
        });
    };
    VirtualWorksheet.prototype.detachFromTable = function () {
        var _this = this;
        this.table.querySelectorAll("td")
            .forEach(function (cell) {
            cell.removeEventListener("mousedown", _this.handleFocus);
            cell.removeEventListener("keydown", _this.handleChangeCellKeyPress);
            cell.removeEventListener("copy", _this.handleCopy);
            cell.removeEventListener("paste", _this.handlePaste);
        });
    };
    VirtualWorksheet.prototype.createCopyEventHandler = function () {
        var self = this;
        return function (e) {
            var e_1, _a;
            var el = e.target;
            var rows = (el.closest("tbody") || el.closest("table") || { rows: null }).rows;
            if (!rows) {
                return null;
            }
            var input = e.target.value ? e.target : null;
            if (input) {
                input.blur();
                input.focus();
            }
            var grid = table_dom_traversal_1.toUnitTable(Array.from(el.closest("tbody").rows || el.closest("table").rows));
            var action = {
                action: "COPY",
                grid: grid,
                dataSelector: self.options.getCellValue,
                selection: new selection_1.CompositeSelection([self.workspace.activeSelection, self.workspace.pastSelection], [])
            };
            var events = clipboard_reducers_1.reduceClipboardAction([], action);
            try {
                for (var events_1 = __values(events), events_1_1 = events_1.next(); !events_1_1.done; events_1_1 = events_1.next()) {
                    var event_1 = events_1_1.value;
                    switch (event_1.event) {
                        case "ERROR":
                            e.preventDefault();
                            console.warn(event_1);
                            alert(event_1.message);
                            return;
                        case "PATTERN_FILLED":
                            var data = clipboard_reducers_1.serializePatternData(event_1.pattern);
                            e.clipboardData.setData("text/plain", data);
                            e.preventDefault();
                            return;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (events_1_1 && !events_1_1.done && (_a = events_1.return)) _a.call(events_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        };
    };
    VirtualWorksheet.prototype.createPasteEventHandler = function () {
        var self = this;
        return function (e) {
            var e_2, _a, e_3, _b;
            var el = e.target;
            var rows = (el.closest("tbody") || el.closest("table") || { rows: null }).rows;
            if (!rows) {
                return null;
            }
            var grid = table_dom_traversal_1.toUnitTable(Array.from(el.closest("tbody").rows || el.closest("table").rows));
            var data = e.clipboardData.getData("text/plain");
            var pattern = clipboard_reducers_1.processPatternData(data);
            var action = {
                action: "PASTE",
                grid: grid,
                pattern: pattern,
                selection: self.workspace.activeSelection
            };
            var events = clipboard_reducers_1.reduceClipboardAction([], action);
            try {
                for (var events_2 = __values(events), events_2_1 = events_2.next(); !events_2_1.done; events_2_1 = events_2.next()) {
                    var event_2 = events_2_1.value;
                    switch (event_2.event) {
                        case "ERROR":
                            e.preventDefault();
                            console.warn(event_2);
                            alert(event_2.message);
                            break;
                        case "SELECTION_FILLED":
                            e.preventDefault();
                            try {
                                for (var _c = (e_3 = void 0, __values(event_2.cellValueChanges)), _d = _c.next(); !_d.done; _d = _c.next()) {
                                    var update = _d.value;
                                    if (self.options.inputValidator(update.cell)) {
                                        self.options.setCellValue(update.cell, update.value);
                                    }
                                }
                            }
                            catch (e_3_1) { e_3 = { error: e_3_1 }; }
                            finally {
                                try {
                                    if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                                }
                                finally { if (e_3) throw e_3.error; }
                            }
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (events_2_1 && !events_2_1.done && (_a = events_2.return)) _a.call(events_2);
                }
                finally { if (e_2) throw e_2.error; }
            }
        };
    };
    VirtualWorksheet.prototype.deleteSelection = function () {
        var e_4, _a, e_5, _b;
        var rows = (this.table.querySelector("tbody") || this.table).rows;
        var grid = table_dom_traversal_1.toUnitTable(Array.from(rows));
        var pattern = [[""]];
        var action = {
            action: "PASTE",
            grid: grid,
            pattern: pattern,
            selection: this.workspace.activeSelection
        };
        var events = clipboard_reducers_1.reduceClipboardAction([], action);
        try {
            for (var events_3 = __values(events), events_3_1 = events_3.next(); !events_3_1.done; events_3_1 = events_3.next()) {
                var event_3 = events_3_1.value;
                switch (event_3.event) {
                    case "ERROR":
                        console.warn(event_3);
                        alert(event_3.message);
                        break;
                    case "SELECTION_FILLED": try {
                        for (var _c = (e_5 = void 0, __values(event_3.cellValueChanges)), _d = _c.next(); !_d.done; _d = _c.next()) {
                            var update = _d.value;
                            if (this.options.inputValidator(update.cell)) {
                                this.options.setCellValue(update.cell, update.value);
                            }
                        }
                    }
                    catch (e_5_1) { e_5 = { error: e_5_1 }; }
                    finally {
                        try {
                            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                        }
                        finally { if (e_5) throw e_5.error; }
                    }
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (events_3_1 && !events_3_1.done && (_a = events_3.return)) _a.call(events_3);
            }
            finally { if (e_4) throw e_4.error; }
        }
    };
    VirtualWorksheet.prototype.createFocusHandler = function () {
        var validInput = this.options.inputSelector;
        var self = this;
        return function handleFocus(e) {
            var el = e.target;
            if (e.button && el.tabIndex !== undefined) {
                return;
            }
            var textbox = e.target.selectionStart ? e.target : null;
            var td = el.tagName === "TD" ? el : el.closest("td");
            if (!td) {
                return;
            }
            var table = table_dom_traversal_1.toUnitTable(Array.from(el.closest("tbody").rows || el.closest("table").rows));
            var cell = table_dom_traversal_1.findCellAddress(td, table);
            if (!textbox) {
                textbox = el.querySelector(validInput);
            }
            if (textbox && self.options.inputValidator(textbox)) {
                if (textbox.focus) {
                    textbox.focus();
                    e.preventDefault();
                    e.stopImmediatePropagation();
                }
                if (textbox.select) {
                    textbox.select();
                }
            }
            var action = {
                action: "SELECT_CELL",
                cell: cell,
                grid: table,
                selectionType: getSelectionType(e)
            };
            self.workspace = workspace_reducers_1.selectionReducer(self.workspace, action);
            self.handleCursorMoved(selection_events_1.createCursorMovedEvent(self.cursor, {
                grid: action.grid,
                cursor: self.workspace.cursor
            }));
            self.handleSelectionChanged(selection_events_1.createSelectionChangeEvent(self.selection, {
                grid: action.grid,
                updatedSelection: new selection_1.CompositeSelection([self.workspace.activeSelection,
                    self.workspace.pastSelection], [])
            }));
        };
    };
    VirtualWorksheet.prototype.createKeyPressHandler = function () {
        var self = this;
        return function handleChangeCellKeyPress(e) {
            if (!e.shiftKey && keyboard_events_1.isKey(e.key, keyboard_events_1.Keys.Delete)) {
                return self.deleteSelection();
            }
            else {
                return self.handleCardinalMovementKeyEvent(e);
            }
        };
    };
    VirtualWorksheet.prototype.clearSelection = function () {
        var action = {
            action: "CLEAR_SELECTION"
        };
        this.workspace = workspace_reducers_1.selectionReducer(this.workspace, action);
    };
    VirtualWorksheet.prototype.handleCardinalMovementKeyEvent = function (e) {
        var el = e.target;
        var cell = el.closest("td");
        if (cell == null) {
            console.warn("onKeyPress called with input not in a table");
            return null;
        }
        var res;
        var newCell;
        var action = {
            action: "CARDINAL_CELL_MOVEMENT"
        };
        action.movementType = getMovementType(e);
        action.direction = getKeyDirection(e);
        if (!action.direction) {
            return;
        }
        action.grid = table_dom_traversal_1.toUnitTable(Array.from(el.closest("tbody").rows || el.closest("table").rows));
        action.sourceCell = table_dom_traversal_1.findCellAddress(cell, action.grid);
        action.traverser = this.traverser;
        this.workspace = workspace_reducers_1.selectionReducer(this.workspace, action);
        if (this.workspace.cursor) {
            newCell = action.grid[this.workspace.cursor.i][this.workspace.cursor.j];
        }
        if (keyboard_events_1.isKey(e.key, keyboard_events_1.Keys.Enter)) {
            e.preventDefault();
            res = false;
        }
        else if (keyboard_events_1.isKey(e.key, keyboard_events_1.Keys.ArrowDown)) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
        else if (keyboard_events_1.isKey(e.key, keyboard_events_1.Keys.ArrowUp)) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
        else if (keyboard_events_1.isKey(e.key, keyboard_events_1.Keys.Tab)) {
            e.preventDefault();
        }
        if (newCell && newCell !== action) {
            var newElement = newCell.querySelector(this.options.inputSelector);
            if (newElement) {
                el.blur();
                newElement.focus();
                var newInput = newElement;
                if (newInput.select) {
                    newInput.select();
                }
            }
        }
        else {
            el.blur();
            el.focus();
        }
        this.handleCursorMoved(selection_events_1.createCursorMovedEvent(this.cursor, {
            grid: action.grid,
            cursor: this.workspace.cursor
        }));
        this.handleSelectionChanged(selection_events_1.createSelectionChangeEvent(this.selection, {
            grid: action.grid,
            updatedSelection: new selection_1.CompositeSelection([this.workspace.activeSelection, this.workspace.pastSelection], [])
        }));
        return res;
    };
    VirtualWorksheet.prototype.handleCursorMoved = function (e) {
        if (!e) {
            return;
        }
        this.cursor = e.cursor;
        if (this.options.onCursorMoved) {
            this.options.onCursorMoved(e);
        }
    };
    VirtualWorksheet.prototype.handleSelectionChanged = function (e) {
        if (!e) {
            return;
        }
        this.selection = e.selection;
        if (this.options.onSelectionChanged) {
            this.options.onSelectionChanged(e);
        }
    };
    return VirtualWorksheet;
}());
exports.VirtualWorksheet = VirtualWorksheet;
function getMovementType(e) {
    if (e.shiftKey && !keyboard_events_1.isKey(e.key, keyboard_events_1.Keys.Tab)) {
        return "extendSelection";
    }
    else {
        return "move";
    }
}
function getSelectionType(e) {
    if (e.shiftKey && !e.ctrlKey) {
        return "extendSelection";
    }
    else if (e.ctrlKey && !e.shiftKey) {
        return "toggle";
    }
    else {
        return "move";
    }
}
function getKeyDirection(e) {
    if (keyboard_events_1.isKey(e.key, keyboard_events_1.Keys.Enter) || keyboard_events_1.isKey(e.key, keyboard_events_1.Keys.ArrowDown)) {
        return "down";
    }
    else if (keyboard_events_1.isKey(e.key, keyboard_events_1.Keys.ArrowUp)) {
        return "up";
    }
    else if (keyboard_events_1.isKey(e.key, keyboard_events_1.Keys.ArrowLeft) && e.ctrlKey) {
        return "left";
    }
    else if (keyboard_events_1.isKey(e.key, keyboard_events_1.Keys.ArrowRight) && e.ctrlKey) {
        return "right";
    }
    else if (keyboard_events_1.isKey(e.key, keyboard_events_1.Keys.Tab)) {
        if (e.shiftKey) {
            return "left";
        }
        else {
            return "right";
        }
    }
    else {
        return;
    }
}
